<template>
  <b-row align-h="center" style="margin-bottom: 40px; text-align: center">
    <b-col cols="12" md="5">
      <h4 class="font-weight-bold mb-4">Input Your Donation</h4>
      <b-form-group>
        <div class="w-100 d-flex justify-content-between align-items-center mb-4 px-3">
          <div class="d-flex flex-column text-left">
            <span class="frequency-text">Donation Frequency</span>
          </div>
          <div class="d-flex flex-column text-right align-items-end">
            <b-form-select
              v-model="frequency"
              :options="frequencyList"
              class="mb-0"
              style="width: 200px"
            ></b-form-select>
          </div>
        </div>
      </b-form-group>
      <div class="range-container">
        <div class="d-flex flex-column align-items-center mb-3">
          <span class="price-approx">{{approxText}}</span>
          <span class="price-text mb-1">${{ inputType==='slider'?sliderPrice:inputPrice}}</span>
          <span class="price-per-month" v-if="frequency!=='one-time'">/month</span>
        </div>
        <div class="d-inline-block w-100 mb-5" v-if="inputType === 'slider'">
          <vue-slider
            v-model="sliderPrice"
            :tooltip="'none'"
            :min="10"
            :max="100"
            :height="8"
            :dot-size="32"
            :dot-style="{background:'#224181'}"
            :process-style="{background:'#224181'}"
            :rail-style="{borderRadius:'0',backgroundColor:'#AAAAAA'}"
            :step-style="{borderRadius:'0',backgroundColor:'rgb(244, 242, 254)'}"
            :interval="10"
            :marks="[10,20,30,40,50,60,70,80,90,100]"
            :contained="true"
            @change="sliderPriceSelect"
          >
            <template v-slot:label="{ label, active }">
              <div :class="['vue-slider-mark-label', 'custom-label',(label===10 || label === 100?'must-show':'must-hide'), { active }]">${{ label }}</div>
            </template>
          </vue-slider>
        </div>
        <div class="d-inline-block w-100 mb-5 position-relative" style="height: 56px" v-if="inputType === 'input'">
          <input @keyup="inputChange" type="number" min="1" max="100" class="form-control input-custom-form" v-model="inputPrice"/>
          <img src="@/assets/dollar.svg" class="position-absolute ml-2" style="top: 10px;left: 10px;"/>
        </div>
        <div class="d-flex justify-content-center mb-5">
          <a class="input-custom cursor-pointer" @click="inputCustom">
            {{ inputType==='slider'?'Input Custom Amount':'Back to Default'}}
          </a>
        </div>

        <button class="btn btn-primary btn-block mb-3" @click="pay">Go to payment</button>
        <div class="text-center d-flex flex-column align-items-center">
          <span style="margin-top:5px;margin-bottom: -3px;">*All prices exclusive of Stripe fees</span>
          <span >*1% additional fee will be added for countries outside US</span>
        </div>
      </div>
    </b-col>
    <div class="w-100"></div>
    <b-col cols="12" md="4" class="d-flex justify-content-center">
      <a class="btn-back d-flex rounded-circle cursor-pointer" @click="back">
        <font-awesome-icon :icon="['fas', 'chevron-left']" class="icon-back" />
      </a>
    </b-col>
  </b-row>
</template>

<script>
import Vue from 'vue';
import VueSlider from 'vue-slider-component';
import { mapActions, mapGetters } from 'vuex';
import helperMixins from '../mixins/helpers.mixins';
import moment from 'moment';

const BASE_URL = process.env.BASE_URL;
export default {
  name: 'Donations',
  mixins: [helperMixins],
  data() {
    return {
      list: [],
      selectedPlan: null,
      donationData: {
        user_currency: '',
        rate: 1,
        country: '',
        currency: '',
        identifier: '',
        price: 0,
        lowest_price: 0,
        recurring: true,
        defaultPrice: 0,
        frequency: 'one-time',
      },
      inputType: 'slider',
      sliderPrice: 10,
      inputPrice: 10,
      donationId: null,
      organization: '',
      frequency: 'one-time',
      frequencyList: [],
    };
  },
  async mounted() {
    if (this.$route.query._d !== undefined) {
      this.donationId = this.$route.query._d;
    } else {
      this.$router.push({ name: 'HomePage' });
      return;
    }
    this.list = [];
    if (this.donationTrxData !== '') {
      Vue.swal({
        title: 'Warning',
        text: 'The other transaction is on the way. Please finish it before create new transaction',
        icon: 'warning',
        confirmButtonText: 'Continue Payment',
        cancelButtonText: 'Cancel Transaction',
        showConfirmButton: true,
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-danger',
        },
      }).then(async (result) => {
        if (result.value) {
          await this.$stripe.redirectToCheckout({
            sessionId: this.donationTrxData.session_id,
          });
        } else {
          this.removePaymentDataDonation();
          this.$router.push({ name: 'HomePage' });
        }
      });
    } else {
      const listPlan = await this.requestListDonationPlan();
      let messageError = '';
      if (this.getStatus !== 200) {
        messageError = this.getMessage;
      } else if (listPlan.length === 0) {
        messageError = 'No option available yet for your country yet. Please try again later';
      }
      if (messageError !== '') {
        if (this.getStatus == 401) {
          Vue.swal({
            title: 'Happy Sabbath!',
            text: messageError,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Back to Home',
            showConfirmButton: false,
            showCancelButton: true,
          }).then(async (result) => {
            this.$router.push({ name: 'HomePage' });
          });
        } else {
          Vue.swal({
            title: 'Warning',
            text: messageError,
            icon: 'warning',
            confirmButtonText: 'Yes',
            cancelButtonText: 'Back to Home',
            showConfirmButton: false,
            showCancelButton: true,
          }).then(async (result) => {
            this.$router.push({ name: 'HomePage' });
          });
        }
      }

      const donationList = await this.requestOnGoingHome();
      const donationFiltered = donationList.find(donat => donat.id == this.donationId);
      if (donationFiltered !== undefined) {
        if (donationFiltered.subscribed){
          Vue.swal({
            title: 'Warning',
            text: 'You are already donated this projects',
            icon: 'warning',
            confirmButtonText: 'Yes',
            cancelButtonText: 'Close',
            showConfirmButton: false,
            showCancelButton: true,
          });
          this.$router.push({ name: 'HomePage' });
        }else{
          this.organization = donationFiltered.organization;
        }

      } else {
        this.$router.push({ name: 'HomePage' });
      }
    }
  },
  computed: {
    ...mapGetters('DonationsModule', ['listDonationPlan']),
    ...mapGetters('PaymentModule', ['donationTrxData']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['getUser', 'getFromApps']),
    approxText() {
      const originPrice = this.inputType === 'slider' ? this.sliderPrice : this.inputPrice;
      const price = (originPrice * this.donationData.rate).toFixed(2);
      return `Approx ${this.donationData.user_currency} ${this.formatPrice(price)}`;
    },
  },
  watch: {
    listDonationPlan: {
      immediate: true,
      deep: true,
      async handler(val) {
        if (this.listDonationPlan != undefined) {
          const subs = this.listDonationPlan;
          this.donationData = {
            ...subs,
            country: subs.country,
            currency: subs.currency,
            identifier: subs.identifier.replaceAll('-', '_'),
            price: subs.price,
            defaultPrice: subs.price,
          };
          this.frequencyList = subs.frequency.map(cr => ({
            value: cr.id,
            text: cr.name,
          }));
        }
      },
    },
  },
  methods: {
    ...mapActions('DonationsModule', ['requestListDonationPlan', 'requestOnGoingHome']),
    ...mapActions('PaymentModule', ['setPaymentDataDonation', 'removePaymentDataDonation', 'requestMakePaymentDonation']),
    ...mapActions('NotificationModule', ['setLoading', 'unsetLoading']),
    sliderPriceSelect(val) {
      this.sliderPrice = val;
    },
    inputChange() {
      if (this.inputPrice < 1) {
        this.inputPrice = 1;
      }
    },
    async pay() {
      this.donationData = { ...this.donationData,
        recurring: true,
        donation_id: this.donationId,
        organization: this.organization,
        frequency: this.frequency,
        price: this.inputType === 'slider' ? this.sliderPrice : this.inputPrice,
      };
      const dataSend = {
        currency: this.donationData.currency,
        amount: this.donationData.price,
        identifier: this.donationData.identifier,
        donation_id: this.donationData.donation_id,
        recurring: this.frequency === 'recurring',
        frequency: this.frequency,
        success_url: this.getFromApps ? `${BASE_URL}/#/transaction-success` : `${BASE_URL}/#/donation-success`,
        cancel_url: `${BASE_URL}/#/transaction-failed`,
      };
      // console.log(dataSend,'ssss');
      const session = await this.requestMakePaymentDonation(dataSend);
      this.donationData = { ...this.donationData, session_id: session.id };
      this.setPaymentDataDonation(this.donationData);
      this.setLoading();
      await this.$stripe.redirectToCheckout({ sessionId: session.id });
      this.unsetLoading();
    },
    inputCustom() {
      if (this.inputType === 'slider') {
        this.inputType = 'input';
      } else {
        this.inputType = 'slider';
      }
    },
    back() {
      this.$router.push({ name: 'HomePage' });
    },
  },
  components: {
    VueSlider,
  },
};
</script>

<style scoped>
  .btn-back{
    background: #C4C4C4;
    display: flex;
    width: 42px;
    height: 42px;
    cursor: pointer;
  }
  .icon-back{
    display: inline-block;
    margin: auto;
    color: #000000;
    font-size: 1.5rem;
  }
  .range-container{
    padding: 32px;
    background: rgba(204, 204, 255,0.24);
    border-radius: 24px;
    margin-bottom: 40px;
  }
  .price-approx{
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
    text-align: center;
    color: #224181;
  }
  .price-text{
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 43px;
    text-align: center;
    color: #224181;
  }
  .price-per-month{
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
  }

  .info-text{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: #767676;
  }

  .rule-1-price{
    color:#F57474;
  }
  .rule-2-price{
    color:#224181;
  }
  .rule-3-price{
    color:#224181;
  }
  .rule-4-price{
    color:#0A84FF;
  }
  .rule-5-price{
    color:#5856D6;
  }
  .rule-6-price{
    color:#FF9F0A;
  }
  .rule-4-info{
    font-weight: 700;
    color:#0A84FF;
  }
  .rule-5-info{
    font-weight: 700;
    color:#5856D6;
  }
  .rule-6-info{
    font-weight: 700;
    color:#FF9F0A;
  }
  .w-90{
    width: 90%;
    height: 34px;
    margin-bottom: 40px;
  }
  .frequency-text{
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    color: #4D4D4D;
  }
  .input-custom{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    text-decoration-line: underline;
    color: #19407F;
  }
  .input-custom-form{
    height: 56px;
    width: 100%;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 43px;
    text-align: right;
    color: #224181;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
</style>



// WEBPACK FOOTER //
// src/views/Donations.vue